import {UiSchema} from "./UiSchema";
import {DataSchemaInterface} from "./DataSchemaInterface";
import {DataInterface} from "./DataInterface";

export class Schemas{

    uiSchema: UiSchema = new UiSchema("", "");
    dataSchema: DataSchemaInterface = {type: "type", properties: {}};
    data: DataInterface = {};

}
